import React,{createContext, useState} from 'react';

import axios from 'axios';

import Utils from './../Utils';

import _ from 'lodash';

const UserContext = createContext();

const UserProvider = (props) => {

  const [userData, setUserData] = useState(Utils.getUserData());
  const [stepData, setUCStepData] = useState({});

  const getPkgSize = () => {
    const slides =  _.get(stepData,'slides', []);    
    const size = _.sum(slides.map(s => ((s.type !== 'Question') && (s.type !== 'Template')) ? parseFloat(_.isUndefined(s.size) ? s.data.size : s.size) : 0));
    return size;
  }

  const getAvailableSize = (minSize) => {
    const scormsize_in_mb = _.get(process.env,'REACT_APP_MAX_SCORM_SIZE',50);
    if(_.min([minSize,scormsize_in_mb - getPkgSize()])!== undefined){
     return Number(_.min([minSize,scormsize_in_mb - getPkgSize()])).toFixed(1);
    }
    //return _.min([minSize,scormsize_in_mb - getPkgSize()]).to;
  }
  const [pkgSize,setPkgSize] = useState();

  const goLogin = ({username, password},callback) => {    
    axios.post(Utils.apiUrl('auth/login'),`&username=${username}&password=${password}`,Utils.apiHeaders()).then(res => {      
      callback(res.data.success,res.data.message, res.data.flag);      
      if(res.data.success){        
        setUserData(res.data.data);        
        Utils.setUserData(res.data);            
      }
    }).catch(err => {
      callback(false, err.message);
    });
  }

  const thirdPartyLogin = (username, callback) => {
    axios.post(Utils.apiUrl('auth/thirdLogin'),`&username=${username}`, Utils.apiHeaders())
        .then(res => {
          callback(res.data.success, res.data.message);
          if(res.data.success){
            setUserData(res.data.data);
            Utils.setUserData(res.data);
          }
        })
        .catch(err => {
          callback(false, err.message);
        });
    
  }
  const goFrgpwd = ({username, password},callback) => {    
    axios.post(Utils.apiUrl('auth/frgpwd'),`&username=${username}`,Utils.apiHeaders()).then(res => {      
      callback(res.data.success,res.data.message, res.data.flag);      
    }).catch(err => {
      callback(false, err.message);
    });
  }



  const goActivate = ({code},callback) => {    
    axios.post(Utils.apiUrl('auth/activate'),`&code=${code}`,Utils.apiHeaders()).then(res => {    
      callback(res.data.success,res.data.message);      
    }).catch(err => {
      callback(false, err.message);
    });
  }

  const changePassword = (data,callback) => {    
    axios.post(Utils.apiUrl('auth/changepwd'),data,Utils.apiHeaders()).then(res => {
      // if(res.data.success === false){
      //   Utils.removeSession();
      //   window.location.href = process.env.PUBLIC_URL + '/login';
      //   return;
      // }    
      callback(res.data.success,res.data.message);      
    }).catch(err => {
      callback(false, err.message);
    });
  }

  const goRegistration = ({name, username, password, picture, source, buyer},callback) => {    
    axios.post(Utils.apiUrl('auth/register'),`&name=${name}&username=${username}&password=${password}&picture=${picture}&source=${source}&buyer=${buyer}`,Utils.apiHeaders()).then(res => {      
      callback(res.data.success,res.data.message,res.data.flag);
      if(res.data.success){
        setUserData(res.data.data);         
        res.data.data = {...res.data.data, selpkg:selectedPackage()};        
        Utils.setUserData(res.data);
      }
    }).catch(err => {
      callback(false, err.message);
    });
  }

  const saveProfile = (data,callback) => {
    axios.post(Utils.apiUrl('auth/saveprofile'),data,Utils.apiHeaders()).then(res => {  
      // if(res.data.success === false){
      //   Utils.removeSession();
      //   window.location.href = process.env.PUBLIC_URL + '/login';
      //   return;
      // }    
      if(res.data.success){
        setUserData(res.data.data);
        Utils.setUserData(res.data);
      }
      callback(res.data.success,res.data.message);      
    }).catch(err => {
      callback(false, err.message);
    });
  }

  const logout = (callback) => {
    setUserData(false);
    Utils.setUserData(false); 
       
    callback();
  }

  const loadPackage = () => {
    return new Promise((resolve,reject) => {
      //axios.get(Utils.apiUrl('../../../js/pkgs.json'),Utils.apiHeaders()).then(res =>{     
        axios.get('/svasu/pkgs.json')
        .then((res) =>{
          Utils.addToUserData({pkgArr:res.data.packages});
          resolve(res.data.packages);          
      }).catch(reject);
    });    
  }

  const getPackage = () => {
    // const pkgArr = _.get(Utils.getUserData(),'pkgArr', false);
    // return pkgArr ? pkgArr.filter(p=>p.id==pkg)[0] : {};
    return _.get(Utils.getUserData(),'pkg', false);
  }

  const setPackage = (pkg) => {
    Utils.addToUserData({selpkg: pkg});  
  }

  const selectedPackage = () => {
    return _.get(Utils.getUserData(),'selpkg', false);
  }
  
  return <UserContext.Provider value={{ userData, getAvailableSize, setUCStepData, getPkgSize, saveProfile, goLogin, goActivate, goFrgpwd, goRegistration, logout, changePassword, 
    setPackage, selectedPackage, getPackage, loadPackage, thirdPartyLogin }}>
    {props.children}
  </UserContext.Provider>;

}

export default UserContext;

export {UserProvider};